import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import '../css/history.css';
import bgImage from "../assets/background-4.jpg";

export default function Privacy() {
  return (
    <>
      <Navbar />
      <PageHeader title="Privacy Policy" path="/privacy" name="Privacy Policy" bgImage={bgImage} />
      <div className="history-page container-xxl py-5">
        <div className="container">
          <div className="history-intro">
            <h1>Our Commitment to Your Privacy</h1>
            <p className="lead">
              This Policy explains how the Democratic Republic of the Yoruba (D.R.Y) handles personal information collected
              through this official website and related online services.
            </p>
          </div>

          <div className="history-section">
            <h3>1. Information We Collect</h3>
            <p>
              We aim to collect only the information that is necessary to deliver public services and improve this website.
            </p>
            <ul>
              <li>Details you submit in forms, such as name, contact information and message content.</li>
              <li>Preferences, such as language or display settings, saved through cookies.</li>
              <li>Anonymous analytics about pages visited, time spent and technical performance.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>2. How We Use Your Information</h3>
            <p>
              Personal information is used for clear and limited purposes connected to the work of the D.R.Y.
            </p>
            <ul>
              <li>Responding to enquiries, requests and applications you send through the site.</li>
              <li>Providing updates about programmes, initiatives or changes you have asked to hear about.</li>
              <li>Maintaining secure access to resources and protecting the website from misuse.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>3. Sharing and Legal Basis</h3>
            <p>
              We do not sell personal data. Any sharing of information is limited and based on lawful grounds.
            </p>
            <ul>
              <li>Data may be shared with relevant ministries or agencies to process your request or enquiry.</li>
              <li>Sharing may be required by law, court order or for the protection of public interests.</li>
              <li>Where third‑party service providers support the website, contracts require them to protect your data.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>4. Retention and Security</h3>
            <p>
              We keep information only for as long as it is needed for the purpose it was collected or as required by law.
            </p>
            <ul>
              <li>Records are stored securely with restricted access.</li>
              <li>Technical safeguards may include encryption, access controls and regular system reviews.</li>
              <li>Older records are archived or securely deleted in line with public records policy.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>5. Your Rights and Choices</h3>
            <p>
              Citizens and users may have rights over their personal data under applicable D.R.Y laws and regulations.
            </p>
            <ul>
              <li>Request access to the information held about you.</li>
              <li>Ask for corrections where details are incomplete or inaccurate.</li>
              <li>In some cases, request deletion or limitation of how your data is used.</li>
              <li>Manage cookie preferences through your browser or device settings.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>6. Updates to This Policy</h3>
            <p>
              This Privacy Policy may be updated to reflect changes in technology, services or legal requirements.
            </p>
            <ul>
              <li>The latest version will always be available on this page.</li>
              <li>Significant updates may be highlighted through notices on the website.</li>
              <li>Continued use of the site after changes means you acknowledge the updated Policy.</li>
            </ul>
          </div>

          <div className="history-section">
            <h3>7. Contact for Privacy Matters</h3>
            <p>
              If you have questions about how your data is handled, or wish to exercise your rights, you can contact us.
            </p>
            <ul>
              <li>Use the contact details provided in the website footer or official communications.</li>
              <li>Include enough information for us to identify you and the request you are making.</li>
              <li>For sensitive matters, avoid sending confidential details in unsecured channels.</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
}
